/**
 * Email list
 */

export const EMAILS_FETCH_FOR_WIDGET = 'EMAILS_FETCH_FOR_WIDGET'

export const EMAILS_FETCH_REQUESTED = 'EMAILS_FETCH_REQUESTED'
export const EMAILS_FETCH_REQUEST_SUCCESS = 'EMAILS_FETCH_REQUEST_SUCCESS'
export const EMAILS_FETCH_REQUEST_ERROR = 'EMAILS_FETCH_REQUEST_ERROR'
export const EMAILS_SET_FILTERS = 'EMAIL_SET_FILTERS'

export const EMAILS_FETCH_MORE_REQUESTED = 'EMAILS_FETCH_MORE_REQUESTED'
export const EMAILS_FETCH_MORE_REQUEST_SUCCESS =
  'EMAILS_FETCH_MORE_REQUEST_SUCCESS'
export const EMAILS_FETCH_MORE_REQUEST_ERROR = 'EMAILS_FETCH_MORE_REQUEST_ERROR'
export const EMAILS_FETCH_NEW_SILENTLY_REQUESTED =
  'EMAILS_FETCH_NEW_SILENTLY_REQUESTED'
export const EMAILS_FETCH_NEW_SILENTLY_SUCCESS =
  'EMAILS_FETCH_NEW_SILENTLY_SUCCESS'

export const EMAILS_UPDATE_SECTION = 'EMAILS_UPDATE_SECTION'

export const EMAILS_REMOVE_FROM_LIST = 'EMAILS_REMOVE_FROM_LIST'

export const EMAILS_MARK_AS_REPLIED_OR_FORWARDED =
  'EMAILS_MARK_AS_REPLIED_OR_FORWARDED'

export const EMAILS_FETCH_STATISTICS_REQUESTED =
  'EMAILS_FETCH_STATISTICS_REQUESTED'
export const EMAILS_FETCH_STATISTICS_SUCCESS = 'EMAILS_FETCH_STATISTICS_SUCCESS'

/**
 * Marking action
 */
export const EMAILS_SET_MARKED_FOR_ACTION = 'EMAILS_SET_MARKED_FOR_ACTION'
export const EMAIL_RESET_MARKED_FOR_ACTION = 'EMAIL_RESET_MARKED_FOR_ACTION'

export const EMAILS_MARKED_UPDATE_READ_STATUS_SINGLE_REQUEST =
  'EMAILS_MARKED_UPDATE_READ_STATUS_SINGLE_REQUEST'
export const EMAILS_MARKED_UPDATE_READ_STATUS_REQUESTED =
  'EMAILS_MARKED_UPDATE_READ_STATUS_REQUESTED'
export const EMAILS_MARKED_UPDATE_READ_STATUS_SUCCESS =
  'EMAILS_MARKED_UPDATE_READ_STATUS_SUCCESS'

export const EMAILS_SET_HANDLED_BY_REQUESTED = 'EMAIL_SET_HANDLED_BY_REQUESTED'
export const EMAILS_SET_HANDLED_BY_SUCCESS = 'EMAIL_SET_HANDLED_BY_SUCCESS'

export const EMAILS_REMOVE_HANDLED_BY_REQUESTED =
  'EMAIL_REMOVE_HANDLED_BY_REQUESTED'
export const EMAILS_REMOVE_HANDLED_BY_SUCCESS =
  'EMAIL_REMOVE_HANDLED_BY_SUCCESS'

export const EMAILS_HANDLE_JUNK_REQUESTED = 'EMAILS_HANDLE_JUNK_REQUESTED'
export const EMAILS_HANDLE_JUNK_SUCCESS = 'EMAILS_HANDLE_JUNK_SUCCESS'
export const EMAILS_HANDLE_JUNK_ERROR = 'EMAILS_HANDLE_JUNK_ERROR'
export const EMAILS_HANDLE_JUNK_RESET = 'EMAILS_HANDLE_JUNK_RESET'

/**
 * Single email
 */
export const EMAIL_SET_CURRENT = 'EMAIL_SET_CURRENT'
export const EMAIL_RESET_CURRENT = 'EMAIL_RESET_CURRENT'

export const EMAIL_FETCH_REQUEST_SUCCESS = 'EMAIL_FETCH_REQUEST_SUCCESS'
export const EMAIL_FETCH_REQUEST_ERROR = 'EMAIL_FETCH_REQUEST_ERROR'

export const EMAIL_FETCH_SILENT_REQUESTED = 'EMAIL_FETCH_SILENT_REQUESTED'
export const EMAIL_FETCH_SILENT_SUCCESS = 'EMAIL_FETCH_SILENT_SUCCESS'
export const EMAIL_FETCH_SILENT_ERROR = 'EMAIL_FETCH_SILENT_ERROR'

export const EMAIL_SET_LABELS = 'EMAIL_SET_LABELS'
export const EMAIL_REMOVE_LABEL = 'EMAIL_REMOVE_LABEL'

export const EMAIL_SET_SINGLE_LIST_ACTION_ID = 'EMAIL_SET_SINGLE_LIST_ACTION_ID'

export const EMAIL_FETCH_SEEN_BY_SUMMARY_REQUESTED =
  'EMAIL_FETCH_SEEN_BY_SUMMARY_REQUESTED'
export const EMAIL_FETCH_SEEN_BY_SUMMARY_SUCCESS =
  'EMAIL_FETCH_SEEN_BY_SUMMARY_SUCCESS'

export const EMAIL_FETCH_SEEN_BY_REQUESTED = 'EMAIL_FETCH_SEEN_BY_REQUESTED'
export const EMAIL_FETCH_SEEN_BY_SUCCESS = 'EMAIL_FETCH_SEEN_BY_SUCCESS'
export const EMAIL_FETCH_SEEN_BY_ERROR = 'EMAIL_FETCH_SEEN_BY_ERROR'

export const EMAIL_SEEN_BY_RESET = 'EMAIL_SEEN_BY_RESET'
export const EMAIL_SEEN_BY_SUMMARY_RESET = 'EMAIL_SEEN_BY_SUMMARY_RESET'

/**
 * Single and marked email
 */
export const EMAIL_DELETE_REQUESTED = 'EMAIL_DELETE_REQUESTED'
export const EMAIL_DELETE_SUCCESS = 'EMAIL_DELETE_SUCCESS'
export const EMAIL_DELETE_ERROR = 'EMAIL_DELETE_ERROR'
export const EMAIL_DELETESTATUS_RESET = 'EMAIL_DELETESTATUS_RESET'

export const EMAIL_RESTORE_REQUESTED = 'EMAIL_RESTORE_REQUESTED'
export const EMAIL_RESTORE_SUCCESS = 'EMAIL_RESTORE_SUCCESS'

export const EMAIL_UPDATE_DRAFT = 'EMAIL_UPDATE_DRAFT'
